import { getMemberDisplayName } from '@/collaboration/utils/members'
import type { MatterMemberRead } from '@/matter/components/manage-members/schemas'

/** user_id to display name lookup for a matter's members. */
export function buildMemberNamesById(members: MatterMemberRead[]): Map<string, string> {
  return new Map(members.map((member) => [member.user_id, getMemberDisplayName(member)]))
}
